import { IApplicationState } from '../../types/redux';

export function selectLoading(state: IApplicationState) {
  const { loading } = state;

  return loading;
}
